import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';

import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { RegisterPage } from './register.page';
import { RouterModule } from '@angular/router';
import { TranslationModule } from '@app/app-translation.module';
import { PipesModule } from '@shared-pipes/pipes.module';
import { FormInputModule } from '@beego/ngx-form-components';

@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		IonicModule,
		ReactiveFormsModule,
		TranslationModule,
		PipesModule,
		FormInputModule,
		RouterModule.forChild([
			{
				path: ':id',
				component: RegisterPage,
			},
			{ path: '', redirectTo: '/login', pathMatch: 'full' },
			{ path: '**', redirectTo: '/login' },
		]),
	],
	declarations: [RegisterPage],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class RegisterPageModule {}
